import { Checkbox, DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutHazardousMaterialsCode extends Layout {
    checkboxIsActive: Checkbox;
    dataheaderHazardousMaterialsCode: DataHeader;
    sourceHazmatCode: DataSource;
    textboxDescr: Textbox;
    textboxHazmatClassCode: Textbox;
    textboxHazmatErgNumber: Textbox;
    textboxHazmatId: Textbox;
    textboxHazmatPackingGroup: Textbox;
    textboxHazmatProperShipname: Textbox;
}
